import * as React from 'react';
import { Fragment, Component } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';
import Icon from './Icon';
import { computed, observable, action } from 'mobx';
import { ReadMoreLessOptions } from '../models/configuration/components/ReadMoreLessOptions';

const ReadMoreLessWrapper = styled<any, any>('div')`
    ${propStyles};
`;

ReadMoreLessWrapper.defaultProps = {
    overflow: 'hidden',
    height: '55px',
};

const ReadMoreLessButton = styled<any, any>('button')`
    ${propStyles};
`;

ReadMoreLessButton.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'body',
    fontWeight: 'normal',
    fontSize: 'sm',
    color: 'gray500',
    bgColor: 'transparent',
    borderStyle: 'none',
    cursor: 'pointer',
    outline: 'none',
    selected: {
        color: 'body',
    },
    padding: '5px 0',
};

const iconProps = {
    height: '1.4em',
    width: '1.4em',
    margin: '0 0 0 0.25em',
};

interface ReadMoreLessProps {
    theme?: { [property: string]: string | number };
    height?: string;
    readMoreLessOptions?: ReadMoreLessOptions;
}

@observer
class ReadMoreLess extends Component<ReadMoreLessProps> {
    @observable expanded = false;

    @action
    toggleReadMore = () => {
        this.expanded = !this.expanded;
    };

    @computed
    get overflow() {
        return this.expanded ? 'visible' : 'hidden';
    }

    @computed
    get height() {
        return this.expanded ? 'auto' : this.props.readMoreLessOptions.height;
    }

    @computed
    get readMoreText() {
        return (
            this.props.readMoreLessOptions &&
            this.props.readMoreLessOptions.readMoreText
        );
    }

    @computed
    get readLessText() {
        return (
            this.props.readMoreLessOptions &&
            this.props.readMoreLessOptions.readLessText
        );
    }

    @computed
    get text() {
        return this.expanded ? this.readLessText : this.readMoreText;
    }

    @computed
    get align() {
        const align =
            (this.props.readMoreLessOptions &&
                this.props.readMoreLessOptions.align) ||
            'right';
        if (align === 'left') {
            return 'auto 0 0 0';
        }

        if (align === 'center') {
            return '0 auto';
        }

        if (align === 'right') {
            return '0 0 0 auto';
        }
    }

    @computed
    get alignIcon() {
        return (
            (this.props.readMoreLessOptions &&
                this.props.readMoreLessOptions.alignIcon) ||
            'right'
        );
    }

    @computed
    get iconFilename() {
        if (
            this.props.readMoreLessOptions &&
            (this.props.readMoreLessOptions.readMoreIcon ||
                this.props.readMoreLessOptions.readLessIcon)
        ) {
            return this.expanded
                ? this.props.readMoreLessOptions.readLessIcon
                : this.props.readMoreLessOptions.readMoreIcon;
        }
    }

    render() {
        const { theme, children } = this.props;
        const {
            toggleReadMore,
            overflow,
            height,
            align,
            alignIcon,
            iconFilename,
            text,
        } = this;

        const icon = (
            <Icon
                fileName={iconFilename}
                {...iconProps}
                {...theme.ReadMoreLessIcon}
            />
        );

        return (
            <Fragment>
                <ReadMoreLessWrapper
                    height={height}
                    overflow={overflow}
                    {...theme.ReadMoreLessWrapper}
                >
                    {children}
                </ReadMoreLessWrapper>
                <ReadMoreLessButton
                    onClick={toggleReadMore}
                    margin={align}
                    {...theme.ReadMoreLessButton}
                >
                    {iconFilename && alignIcon === 'left' && (
                        <Fragment>{icon}</Fragment>
                    )}
                    {text && <Translate>{text}</Translate>}
                    {iconFilename && alignIcon === 'right' && (
                        <Fragment>{icon}</Fragment>
                    )}
                </ReadMoreLessButton>
            </Fragment>
        );
    }
}

export default withTheme(ReadMoreLess);



// WEBPACK FOOTER //
// ./src/Components/ReadMoreLess.tsx